import { EventType, Notification } from '@notifee/react-native';
import { OrderImportSourceEnum } from '../utils/helpers/enum';
import { QueryType } from '../grow-dashboard/model';

export enum ChannelType {
  Channel = 'channel',
  Thread = 'thread',
}

export interface Miscellaneous {
  notificationData: {
    notification?: Notification;
    eventType?: EventType;
  };
  channelInfo: {
    id: string;
    type?: ChannelType;
  };
  sellerStoreData: {
    tokens: {
      token: string;
      refreshToken: string;
      role: string;
    };
  };
  appParams: AppParams;
  selectedChannelWorkspaceID: string;
  cartModalState?: boolean;
  extendedCartState?: boolean;
  retryPolicies: {
    [id: string]: {
      count: number;
      time: number;
    };
  };
  navigateFromChannel: string;
  headerVisible?: boolean;
  selectedCustomer?: string;
  version?: string;
  selectedCartTab: OrderImportSourceEnum;
  isZonoMoney: boolean;
  runTour?: boolean;
  activeKeyboardHandler: any;
  bottomTabBarHeight: number;
  topHeaderHeight: number;
  tabsCurrentIndex: {
    [screen: string]: number;
  };
  selectedPos: string[];
  isDistributorFlow: boolean;
  sharedIntent: SharedIntent | null;
  fromSellerAction: boolean;
  isAssignTags: boolean;
  successOrderModal: SuccessOrderModal;
  turnoverInvoiceSuccessModal: TurnoverInvoiceSuccessModal;
  schemeType: 'POINTS' | 'VALUE';
  invoicesToInclude: 'PRIMARY' | 'SECONDARY' | 'BOTH' | 'ALL';
  slabLevel: 'Global' | 'Scheme Level';
  growQueryConversationThread: GrowConverationThread;
  threadSummaryTimeRange: ThreadSummaryTimeRange;
  queryAnalysisList: QueryType[];
}

export interface GrowConverationThread {
  channelId: string;
  startTimeToken: string;
  endTimeToken: string;
  isGrowConversation: boolean;
  conversationId: string;
  backgroundColor: string;
  queryType: string;
  title: string;
}

export type ThreadSummaryTimeRange =
  | 'LAST_24_HOURS'
  | 'LAST_3_DAYS'
  | 'LAST_7_DAYS'
  | 'LAST_15_DAYS'
  | 'LAST_30_DAYS'
  | 'LAST_60_DAYS';

export interface AppParams {
  route: string;
  queryParams: string;
  cartCount?: number;
}

export interface SharedIntent {
  uri: string;
  type: string;
  size: number;
  name: string;
}

export enum SuccessOrderModalType {
  CANCELLED = 'Cancelled',
  CHECKOUT = 'Checkout',
  SUBMITTED = 'Submitted',
  APPROVED = 'Approved',
}

export interface SuccessOrderModal {
  isOpen: boolean;
  type: SuccessOrderModalType | null;
  isOnlyNavigateToThreads?: boolean;
  data?: {
    skuCount?: number;
    orderNo?: string;
    customerName?: string;
  };
}

export interface TurnoverInvoiceSuccessModal {
  isOpen: boolean;
  invoiceNumber?: string;
  contributionValue?: string;
  status?: 'APPROVED' | 'REJECTED';
  rejectionReason?: string;
}
